define([
	"dojo/_base/declare",
	"csi/heading/Time",
	"csi/types"
], function(declare,Time,types) {
	return declare(Time, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			//sets the date to show full year
			return types.formatTime(value, fmt, {fullYear: true});
		}
	});
});